import { render, staticRenderFns } from "./sakip.vue?vue&type=template&id=7b284616&"
import script from "./sakip.vue?vue&type=script&lang=js&"
export * from "./sakip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports